/* eslint-disable arrow-body-style */
/* eslint-disable react/function-component-definition */
/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import React from 'react'
import { graphql } from 'gatsby'

// Components
import SEO from 'components/SEO'
import Layout from 'components/shared/Layout'
import FooterLanding from 'components/shared/FooterLanding'
import HeroLanding from '../components/elements/HeroLanding'
import HeroIntroLanding from '../components/elements/HeroIntroLanding'
import HeroDetailLanding from '../components/elements/HeroDetailLanding'
import TextLinkLanding from '../components/elements/TextLinkLanding'
import ServicesInlineLanding from '../components/elements/ServicesInlineLanding'
import Partners from '../components/elements/Partners'
import QuoteLanding from '../components/elements/QuoteLanding'
import ProjectsLanding from '../components/elements/ProjectsLanding'
import CtaLanding from '../components/elements/CtaLanding'
import FaqLanding from '../components/elements/FaqLanding'
import ContactLanding from '../components/elements/ContactLanding'

export const pageQuery = graphql`
  query ($id: String) {
    page: wpPage(id: { eq: $id }) {
      title
      uri
      pageLanding {
        bannerLanding {
          title
          titleunder
          image {
            localFile {
              childImageSharp {
                gatsbyImageData(width: 2000, quality: 100)
                meta: fluid(maxWidth: 800, toFormat: JPG) {
                  src
                }
              }
            }
          }
          link {
            title
            url
            target
          }
          secondLink {
            title
            url
            target
          }
        }

        bannerIntroductionLanding {
          subtitle
          title
          description
        }

        textBlockLanding {
          title
          description
        }

        whyC3Landing {
          title
          items {
            icon {
              localFile {
                publicURL
              }
            }
            link {
              title
              url
              target
            }
          }
          cta {
            description
            link {
              title
              url
              target
            }
          }
        }

        quoteLanding {
          quote
        }

        projectsLanding {
          title
          projects {
            ... on WpProject {
              id
              databaseId
              uri
              title
              content
              projectrecap {
                locatie
                banner {
                  localFile {
                    childImageSharp {
                      gatsbyImageData(width: 450, height: 320, quality: 100)
                    }
                  }
                }
                livestream {
                  image {
                    localFile {
                      childImageSharp {
                        gatsbyImageData(width: 255, quality: 100)
                      }
                    }
                  }
                  iframe
                }
              }
            }
          }
        }

        partnersLanding {
          title
          images {
            localFile {
              childImageSharp {
                gatsbyImageData(width: 400, quality: 100)
              }
            }
          }
        }

        bannerDownloadLanding {
          subtitle
          title
          description
          image {
            localFile {
              childImageSharp {
                gatsbyImageData(width: 2000, quality: 100)
              }
            }
          }
          link {
            title
            url
            target
          }
        }

        ctaLanding {
          description
          image {
            localFile {
              childImageSharp {
                gatsbyImageData(width: 2000, quality: 100)
              }
            }
          }
          link {
            title
            url
            target
          }
        }

        faqLanding {
          title
          questions {
            ... on WpVraag {
              id
              title
              content
            }
          }
          link {
            title
            url
            target
          }
        }

        contactLanding {
          title
          description
        }
      }
      seo {
        canonical
        cornerstone
        focuskw
        metaDesc
        metaKeywords
        metaRobotsNofollow
        metaRobotsNoindex
        opengraphAuthor
        opengraphDescription
        opengraphModifiedTime
        opengraphPublisher
        opengraphPublishedTime
        opengraphSiteName
        opengraphTitle
        opengraphType
        opengraphUrl
        title
        twitterDescription
        twitterTitle
        opengraphImage {
          sourceUrl
        }
        twitterImage {
          sourceUrl
        }
      }
    }
  }
`

const PageTemplate = ({
  data: {
    page: { pageLanding, seo },
  },
}) => {
  const {
    bannerLanding,
    bannerIntroductionLanding,
    textBlockLanding,
    whyC3Landing,
    quoteLanding,
    projectsLanding,
    partnersLanding,
    bannerDownloadLanding,
    ctaLanding,
    faqLanding,
    contactLanding,
  } = pageLanding || {}

  return (
    <Layout bare>
      {seo && <SEO seo={seo} />}

      {bannerLanding && bannerLanding.title && (
        <HeroLanding
          title={bannerLanding.title}
          titleOutline={bannerLanding.titleunder}
          image={bannerLanding.image}
          link={bannerLanding.link}
          secondLink={bannerLanding.secondLink}
        />
      )}

      {bannerIntroductionLanding && bannerIntroductionLanding.description && (
        <HeroIntroLanding
          subtitle={bannerIntroductionLanding.subtitle}
          title={bannerIntroductionLanding.title}
          description={bannerIntroductionLanding.description}
        />
      )}

      {textBlockLanding && (
        <TextLinkLanding
          title={textBlockLanding.title}
          description={textBlockLanding.description}
        />
      )}

      {bannerDownloadLanding && bannerDownloadLanding.description && (
        <HeroDetailLanding
          subtitle={bannerDownloadLanding.subtitle}
          title={bannerDownloadLanding.title}
          description={bannerDownloadLanding.description}
          image={bannerDownloadLanding.image}
          link={bannerDownloadLanding.link}
        />
      )}

      {whyC3Landing && whyC3Landing.items && (
        <ServicesInlineLanding services={whyC3Landing} />
      )}

      {partnersLanding && (
        <Partners
          title={partnersLanding.title}
          images={partnersLanding.images}
        />
      )}

      {quoteLanding && quoteLanding.quote && (
        <QuoteLanding quote={quoteLanding.quote} />
      )}

      {projectsLanding && projectsLanding.projects && (
        <ProjectsLanding projects={projectsLanding} />
      )}

      {ctaLanding && ctaLanding.link && ctaLanding.description && (
        <CtaLanding cta={ctaLanding} />
      )}

      {faqLanding && (
        <FaqLanding
          title={faqLanding.title}
          questions={faqLanding.questions}
          link={faqLanding.link}
        />
      )}

      {contactLanding && (
        <ContactLanding
          title={contactLanding.title}
          description={contactLanding.description}
        />
      )}

      <FooterLanding />
    </Layout>
  )
}

export default PageTemplate
